import styled from "styled-components";

export const Container = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: auto;
  margin-top: 10rem;

  p {
    font-family: "Nunito sans", sans-serif;
    font-size: 1.5rem;
    color: var(--gray-1);
    line-height: 1.5;
    letter-spacing: 0.02em;
  }
`;

export const SubContainer = styled.div`
  width: 50%;
  padding: 15px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

export const ButtonContainer = styled.div`
  width: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const Link = styled.a`
  width: 80%;
  text-align: center;
  font-size: 2.5rem;
  padding: 2.5rem 10rem;
  background: linear-gradient(
    to right,
    #654ad2 0%,
    #2173cf 40%,
    #247ccc 49%,
    #36b1bd 100%
  );
  color: var(--white) !important;
  font-weight: 600;
  font-family: "Nunito sans", sans-serif;
  border: none;
  border-radius: 5px;
  transition: all 0.3s ease;

  &:hover {
    cursor: pointer;
    background: linear-gradient(
      to right,
      #654ad2 0%,
      #2173cf 20%,
      #247ccc 30%,
      #36b1bd 100%
    );
  }
`;

export const Title = styled.h1`
  font-size: 5.5rem;
  text-align: start;
  background: linear-gradient(
    to right,
    #654ad2 0%,
    #2173cf 40%,
    #247ccc 49%,
    #36b1bd 100%
  );
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
`;
